module.exports = "https://img.zhijierongxing.com/saas/img/menu5.d10e84ec.png";